const scope_0 = require('/opt/build/repo/.cache/caches/gatsby-mdx/mdx-scopes-dir/1970366a8c100bb8e42caab4bfa24659.js').default;
const scope_1 = require('/opt/build/repo/.cache/caches/gatsby-mdx/mdx-scopes-dir/6f1bb562f9556200ee8808e7fdaceab7.js').default;
const scope_2 = require('/opt/build/repo/.cache/caches/gatsby-mdx/mdx-scopes-dir/7d40ee70ff69a6ad2a4b071607b2c292.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    